var _templateObject;

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import styled, { css } from 'styled-components';
import gql from 'graphql-tag';
import { Text, spaceMixin, mediaMixin } from '@zillow/constellation';
import { comma } from '@zillow/formatters';
import { getHomeStatusDisplayData } from '@zillow/home-status-display-data';
import { formatAddress, splitAddressLines } from '../utils/addressUtils';
import StatusIcon from './StatusIcon';
var StyledDiv = styled.div.withConfig({
  displayName: "HomeInfo__StyledDiv",
  componentId: "sc-16m4d90-0"
})(["height:200px;position:relative;overflow:hidden;width:100%;"]);
var StyledImage = styled.img.withConfig({
  displayName: "HomeInfo__StyledImage",
  componentId: "sc-16m4d90-1"
})(["position:absolute;transform:translateY(-50%);width:100%;top:50%;"]);
var ImageTintCover = styled.div.withConfig({
  displayName: "HomeInfo__ImageTintCover",
  componentId: "sc-16m4d90-2"
})(["position:absolute;background-color:rgba(25,52,91,0.75);height:100%;width:100%;top:0;"]);
var StyledHomeInformation = styled.div.withConfig({
  displayName: "HomeInfo__StyledHomeInformation",
  componentId: "sc-16m4d90-3"
})(["padding:", ";position:absolute;top:0;", ";"], spaceMixin(2.5), mediaMixin('md_lte', css(["padding:", ";"], spaceMixin(1.25))));
var OwnerDashboardLinkContainer = styled.a.withConfig({
  displayName: "HomeInfo__OwnerDashboardLinkContainer",
  componentId: "sc-16m4d90-4"
})(["position:absolute;right:30px;bottom:20px;"]);

var HomeInfo = function HomeInfo(_ref) {
  var _property$photos;

  var property = _ref.property,
      _ref$abTests = _ref.abTests,
      abTests = _ref$abTests === void 0 ? {} : _ref$abTests,
      ownerDashboardLink = _ref.ownerDashboardLink;
  var fullAddress = formatAddress(property);
  var fullAddressSplit = splitAddressLines(fullAddress);
  var homeStatus = property.homeStatus === 'OTHER' ? 'OFF MARKET' : property.homeStatus;

  var _getHomeStatusDisplay = getHomeStatusDisplayData(property.homeStatus, property.homeType, false, property.listing_sub_type, property.contingentListingType, abTests),
      icon = _getHomeStatusDisplay.icon;

  var bedsBathsSqft = [{
    content: (property.bedrooms ? property.bedrooms : '--') + " bds",
    predicate: property.bedrooms
  }, {
    content: (property.bathrooms ? property.bathrooms : '--') + " ba",
    predicate: property.bathrooms
  }, {
    content: (property.livingArea ? comma(property.livingArea) : '--') + " sqft",
    predicate: property.livingArea
  }].filter(function (_ref2) {
    var predicate = _ref2.predicate;
    return predicate;
  }).map(function (_ref3) {
    var content = _ref3.content;
    return content;
  }).join(' · ');
  return /*#__PURE__*/React.createElement(StyledDiv, {
    "data-testid": "home-info"
  }, /*#__PURE__*/React.createElement(StyledImage, {
    src: (_property$photos = property.photos) === null || _property$photos === void 0 ? void 0 : _property$photos[0].url
  }), /*#__PURE__*/React.createElement(ImageTintCover, null), /*#__PURE__*/React.createElement(StyledHomeInformation, null, /*#__PURE__*/React.createElement(StatusIcon, {
    icon: icon
  }), /*#__PURE__*/React.createElement(Text, {
    "data-testid": "status",
    fontType: "bodySmallHeading",
    fontColor: "white"
  }, homeStatus.replace(/_/g, ' '), /*#__PURE__*/React.createElement("br", null)), /*#__PURE__*/React.createElement(Text, {
    "data-testid": "address",
    fontType: "h4",
    fontColor: "white",
    mediaQuery: {
      md: {
        fontType: 'h3'
      }
    }
  }, fullAddressSplit[0], /*#__PURE__*/React.createElement("br", null), fullAddressSplit[1], /*#__PURE__*/React.createElement("br", null)), /*#__PURE__*/React.createElement(Text, {
    "data-testid": "bedsBathsSqft",
    fontType: "h6",
    fontColor: "white"
  }, bedsBathsSqft)), property.zpid && /*#__PURE__*/React.createElement(OwnerDashboardLinkContainer, null, ownerDashboardLink));
};

HomeInfo.fragments = {
  property: gql(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n        fragment HomeInfo_property on Property {\n            streetAddress\n            city\n            state\n            zipcode\n            bedrooms\n            bathrooms\n            livingArea\n            homeStatus\n            homeType\n            contingentListingType\n            photos(size: XL) {\n                url\n            }\n            listing_sub_type {\n                is_newHome\n                is_FSBO\n                is_bankOwned\n                is_foreclosure\n                is_forAuction\n                is_comingSoon\n            }\n        }\n    "])))
};
export default HomeInfo;
//# sourceMappingURL=HomeInfo.js.map